// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"e5ed4339","360":"d184965e","379":"7fdbc7d0","477":"d4c163cc","523":"b6371884","697":"088d7259"}[chunkId] + ".chunk.js";
};